import { useApiMutation } from "./use-api-mutation";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

type ReplayWebhookParams = {
	returnRequestId: string;
	action: string;
};

export default function useReplayWebhook(shopId: string) {
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useApiMutation(
		"post",
		"/shops/{shopId}/webhooks/replay-webhook",
		{
			onSuccess: (_, variables: ReplayWebhookParams) => {
				invalidateReturnRequest({
					shopId,
					returnRequestId: variables.returnRequestId,
				});
			},
			mapVariables: ({ returnRequestId, action }: ReplayWebhookParams) => ({
				params: { path: { shopId } },
				body: {
					returnRequestId,
					action,
				},
			}),
		},
	);
}
